import { FatalAttraction as FA } from '@vpr/tracking';

import { translate } from '@vimeo/i18n-runtime';

import styles from './ToggleButton.module.scss';

const ToggleButton = ({
  tracklistExpanded,
  isMobile,
  toggleTracklist,
  ariaExpanded,
  ariaControls,
  ariaLabel,
}) => {
  const tooltipText = `${tracklistExpanded ? translate('Hide') : translate('View all')}`;
  const className = `${styles.playlistPlaybarCaret} ${isMobile ? '' : styles.playlistTooltip} ${
    styles.playlistTooltipChevron
  }`;

  const iconContainerStyle = `${styles.toggleIconContainer} ${
    tracklistExpanded ? styles.expanded : ''
  }`;

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggleTracklist();
      FA.trackClick({
        container: 'embedded_playlist',
        component: tracklistExpanded ? 'collapse_options' : 'expand_options',
      });
    }
  };

  return (
    <button
      className={className}
      data-tooltip-text={tooltipText}
      onClick={() => {
        toggleTracklist();
        FA.trackClick({
          container: 'embedded_playlist',
          component: tracklistExpanded ? 'collapse_options' : 'expand_options',
        });
      }}
      onKeyDown={handleKeyDown}
      aria-expanded={ariaExpanded}
      aria-controls={ariaControls}
      aria-label={ariaLabel || tooltipText}
    >
      <div className={iconContainerStyle}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M12 15.5a1 1 0 0 1-.67-.26l-5-4.5 1.34-1.48L12 13.15l4.33-3.9 1.34 1.49-5 4.5a1 1 0 0 1-.67.26z"
            fill="#ffffff"
          />
        </svg>
      </div>
    </button>
  );
};

export default ToggleButton;
